import BrandsSection from "../Sections/BrandsSection";
import BottomFooterBrands from "../Sections/bottomFooterBrands";
import WhatsappWidget from "../Components/Whatsapp Widget/WhatsappWidget";

function Brands() {
  return (
    <>
      <BrandsSection />
      <BottomFooterBrands />
      <WhatsappWidget />
    </>
  );
}

export default Brands;
